module.exports = __webpack_public_path__ + "static/media/Neuquen.4b7bc68f.svg";